{
  "id": "ibge",
  "nome": "IBGE Localidades",
  "fonte": "IBGE API v1 /localidades",
  "endpoints": [
    "https://servicodados.ibge.gov.br/api/v1/localidades/estados",
    "https://servicodados.ibge.gov.br/api/v1/localidades/municipios"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T05:40:09.308Z",
  "contagens": {
    "estados": 27,
    "municipios": 5571
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T05:40:09.308Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#ibge-localities"
}
